import { getAtmosphereAssetUrls } from '../screens/components/atomic/atmosphere/atmosphereAssets';
import { getDeliveryPopupAssetUrls } from '../screens/components/atomic/dialog/delivery_popups/deliveryPopupAssets';
import { getAllLevelCharacterSpriteUrls } from '../screens/level_screen/gameplay/characterLevelSprites';
import { getLoadingScreenAssetUrls } from '../screens/loading_screen/loadingScreenAssets';
import { getAllDeliveryCompletedAssetUrls } from '../screens/map_screen/all_delivery_completed/allDeliveryCompletedAssets';
import { getMapGiantAssetUrls } from '../screens/map_screen/giants/mapGiantAssets';
import { getMapLandAssetUrls } from '../screens/map_screen/lands/mapLandAssets';
import { getMapHudAssetUrls } from '../screens/map_screen/mapHudAssets';
import { getWelcomeAssetUrls } from '../screens/welcome_delivery_1/welcomeAssetUrls';
import { getDeliveryDialogAssetUrls } from './deliveryDialogAssets';
import { getDeliveryListAssetUrls } from './deliveryListAssets';

function dedupeUrls(urls: readonly string[]): string[] {
  const seen = new Set<string>();
  const result: string[] = [];
  for (const url of urls) {
    if (url === '' || seen.has(url)) {
      continue;
    }
    seen.add(url);
    result.push(url);
  }
  return result;
}

/**
 * Critical-path URLs for stage-1 preload (loading → welcome → map → delivery UI).
 * Per-giant level art loads in ensureGiantLevelAssets on level enter.
 */
export function collectCriticalAssetUrls(): string[] {
  return dedupeUrls([
    ...getLoadingScreenAssetUrls(),
    ...getWelcomeAssetUrls(),
    ...getAtmosphereAssetUrls(),
    ...getMapLandAssetUrls(),
    ...getMapGiantAssetUrls(),
    ...getMapHudAssetUrls(),
    ...getDeliveryDialogAssetUrls(),
    ...getDeliveryPopupAssetUrls(),
    ...getAllDeliveryCompletedAssetUrls(),
    ...getDeliveryListAssetUrls(),
    ...getAllLevelCharacterSpriteUrls(),
  ]);
}

/** @deprecated Use {@link collectCriticalAssetUrls}. */
export function collectBootstrapAssetUrls(): string[] {
  return collectCriticalAssetUrls();
}
